function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  z-index: 5;\n  background-color: #ecf0f3;\n  border-color: #d1d5da;\n  height: ",
        ";\n  align-items: center;\n  border-bottom: 1px solid #dbdbdb;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  justify-content: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  color: #6d747b;\n  font-weight: bold;\n  font-size: 16px;\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  top: 12px;\n  right: 15px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Flex, Image } from '@dutchie/common/components/rebass-compat';
import { ModalClose } from './index';
import { ResetButton } from '../components';
import { colors } from '../styles';
var Container = styled(function(props) {
    return /*#__PURE__*/ _jsx(Flex, _object_spread({}, props));
})(_templateObject(), function(props) {
    return props.height ? props.height : '60px';
}, function(props) {
    if (props.centered) {
        return 'center';
    }
    if (props.textButton) {
        return 'space-between';
    }
    return 'flex-start';
}, function(props) {
    if (props.textButton) {
        return '4px 60px 0 33px';
    }
    return '1px 33px 0 33px';
});
var Header = styled(function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx("h2", _object_spread_props(_object_spread({}, props), {
        children: children
    }));
})(_templateObject1(), function(props) {
    return props.icon && "\n    margin-left: 12px;\n  ";
}, function(props) {
    return props.centered && "\n    font-size: 20px;\n  ";
});
var Close = styled(ModalClose)(_templateObject2());
var TextButton = styled(function(props) {
    return /*#__PURE__*/ _jsx(ResetButton, _object_spread({
        color: colors.blue
    }, props));
})(_templateObject3());
export default function(_param) {
    var _param_icon = _param.icon, icon = _param_icon === void 0 ? false : _param_icon, copy = _param.copy, _param_textButton = _param.textButton, textButton = _param_textButton === void 0 ? false : _param_textButton, _param_textButtonFunc = _param.textButtonFunc, textButtonFunc = _param_textButtonFunc === void 0 ? false : _param_textButtonFunc, close = _param.close, _param_centered = _param.centered, centered = _param_centered === void 0 ? false : _param_centered, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, props = _object_without_properties(_param, [
        "icon",
        "copy",
        "textButton",
        "textButtonFunc",
        "close",
        "centered",
        "disabled"
    ]);
    return /*#__PURE__*/ _jsxs(Container, _object_spread_props(_object_spread({
        textButton: textButton,
        centered: centered
    }, props), {
        children: [
            icon && /*#__PURE__*/ _jsx(Image, {
                width: "24px",
                src: icon
            }),
            /*#__PURE__*/ _jsx(Header, {
                centered: centered || undefined,
                icon: icon || undefined,
                children: copy
            }),
            textButton && /*#__PURE__*/ _jsx(TextButton, {
                onClick: textButtonFunc,
                children: textButton
            }),
            !disabled && /*#__PURE__*/ _jsx(Close, {
                "data-testid": "modal-x",
                onClick: close
            })
        ]
    }));
};
